class BaseTreeSearchController extends BaseSearchController
	@register()
	@inject '$rootScope',
		'$state'
		'treeItems'
		'NodeTranslationService'

	initialize: ->
		@searchOnInit = false

		super()

	onSelect: (node) ->
		@$state.go '^.details', {id: node.id}

	initialize: ->
		super(false)

		@NodeTranslationService.configure {
			id: 'id'
			name: 'name'
			parentIndicator: 'parent_id'
		}

		@updateItems(@treeItems)

	updateItems: (items) ->
		tmpItems = angular.copy(items)

		@nodesTree = _.sortBy(
			@NodeTranslationService.translate(_.values(tmpItems)),
			(node) ->
				node.name.toLowerCase()
		)

	afterSetItem: (item) ->
		existingItem = _.find @treeItems, {id: item.id}

		if existingItem?
			existingItem = angular.merge(existingItem, item)
		else
			@treeItems.push(item)

		@updateItems(@treeItems)

		super(item)

	afterRemoveItem: (item) ->
		@treeItems = _.reject @treeItems, {id: item.id}

		@updateItems(@treeItems)

		super(item, false, {reload: true})
